import { listVideoTemplates } from "~/api/videoTemplate"
import type { RequestOptions } from "~/common/request"
import { readVideoTemplate } from "./config"
import type { VideoTemplate } from "./types"

export type TemplatePage = { items: VideoTemplate[]; total: number }

export const loadVideoTemplatePage = async (
  params: API.VideoTemplate.ListParams,
  options?: RequestOptions,
): Promise<TemplatePage> => {
  options?.signal?.throwIfAborted()
  const { data } = await listVideoTemplates(params, {
    ...options,
    notify: false,
  })
  if (
    !data ||
    !Array.isArray(data.items) ||
    !Number.isInteger(data.total) ||
    data.total < 0
  )
    throw new Error("模板列表返回格式无效，请重试")
  const items = data.items.map(readVideoTemplate)
  if (new Set(items.map((item) => item.templateId)).size !== items.length)
    throw new Error("模板列表存在重复标识，请重试")
  return { items, total: data.total }
}

export const loadVideoTemplateCatalog = async (
  params: Pick<API.VideoTemplate.ListParams, "categories" | "template_id"> = {},
  options?: RequestOptions,
): Promise<VideoTemplate[]> => {
  const templates: VideoTemplate[] = []
  const ids = new Set<string>()
  const pageSize = 100
  let total: number | undefined
  const readPage = async (page: number): Promise<VideoTemplate[]> => {
    options?.signal?.throwIfAborted()
    const data = await loadVideoTemplatePage(
      { ...params, page, page_size: pageSize },
      { ...options, notify: false },
    )
    if (total !== undefined && data.total !== total)
      throw new Error("模板列表返回格式无效或已变化，请重试")
    total = data.total
    for (const template of data.items) {
      if (ids.has(template.templateId))
        throw new Error("模板列表存在重复标识，请重试")
      ids.add(template.templateId)
      templates.push(template)
    }
    if (templates.length === total) return templates
    if (!data.items.length || templates.length > total)
      throw new Error("模板列表分页数据不完整，请重试")
    return readPage(page + 1)
  }
  return readPage(0)
}
